import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import styles from './Inputs.module.scss';

export interface IMultiSelectInputOption {
    id: string;
    label: string;
}

export interface IMultiSelectInputProps {
    value?: IMultiSelectInputOption[];
    options: IMultiSelectInputOption[];
    disabled?: boolean;
    required?: boolean;
    handleChange: (selected: IMultiSelectInputOption[]) => void;
}

const MultiSelectInput: React.FC<IMultiSelectInputProps> = (props: IMultiSelectInputProps) => {
    const isControlled = props.value !== undefined;

    const [internalValue, setInternalValue] = useState<IMultiSelectInputOption[]>(props.value ?? []);
    const [touched, setTouched] = useState(false);

    const currentValue = isControlled ? props.value ?? [] : internalValue;

    useEffect(() => {
        if (isControlled) {
            setInternalValue(props.value ?? []);
        }
    }, [isControlled, props.value]);

    const commit = (next: IMultiSelectInputOption[]) => {
        if (!isControlled) {
            setInternalValue(next);
        }
        props.handleChange(next);
    };

    const isError = !!props.required && touched && currentValue.length === 0 && !props.disabled;

    return (
        <Autocomplete
            multiple
            disabled={props.disabled}
            options={props.options}
            value={currentValue}
            onChange={(_, newValue) => {
                setTouched(true);
                commit(newValue);
            }}
            getOptionLabel={(o) => o.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            filterSelectedOptions
            className={isError ? styles.input_multiselect_container_error : styles.input_multiselect_container}
            classes={{
                inputRoot: styles.input_multiselect_root,
                tag: styles.input_multiselect_tag,
                input: styles.input_multiselect,
            }}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => <Chip label={option.label} {...getTagProps({ index })} />)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    fullWidth
                    error={isError}
                    onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                        setTouched(true);
                        params.inputProps.onBlur?.(event);
                    }}
                />
            )}
        />
    );
};

export default MultiSelectInput;
